<page-loading-spinner [initialized]="initialized"></page-loading-spinner>
<charts-wrapper [consumptionData]="consumptionData"></charts-wrapper>
